<template>
  <div class="shop__list">
    <ShopListItem
      v-for="(box, index) in getShopListFiltered"
      :key="index"
      :box="box"
      @stopBoxesScroll="stopBoxesScroll"
    ></ShopListItem>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ShopListItem from "./ShopListItem";

export default {
  name: "ShopList",

  components: { ShopListItem },

  computed: {
    ...mapGetters("shop", ["getShopList", "getShopView", "isFavoriteEmpty"]),

    getShopListFiltered() {
      return this.getShopView === "favorite"
        ? this.getShopList.filter(item => item.favorite)
        : this.getShopList;
    },
  },

  methods: {
    stopBoxesScroll() {
      this.$emit("stopBoxesScroll");
    },
  },
};
</script>
